export enum TaskTypeEnum {
    FOLLOW_UP = "Follow-up",
    MANDATORY = "Mandatory",
    REMINDER = "Reminder"
}